import  {React,useState}from "react";
import "./Contact.css";
import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope, FaMoneyCheckAlt, FaPaperPlane } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import Footer from '../../components/Footer/Footer';
import NavBar from "../../components/NavBar/NavBar";
import { useLanguage } from "../../contexts/LanguageContext";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { getCountryCode, parsePhoneNumber } from 'libphonenumber-js';
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import FloatingWebsiteNavigation from "../../components/FloatingWebsiteNavigation/FloatingWebsiteNavigation";


const Contact = () => {
    const { translations: t, language } = useLanguage();
    const isRTL = language === 'ar' || language === 'fa' || language === 'ur';
     const [phoneValue, setPhoneValue] = useState('');
  const [countryCode, setCountryCode] = useState('AE');
  const [selectedEmail, setSelectedEmail] = useState('support@iwinto.com');

  const cardVariants = {
    offscreen: {
      y: 50,
      opacity: 0
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8
      }
    }
  };
   
    const handlePhoneChange = (value) => {
        setPhoneValue(value);
        if (value) {
            try {
                const phoneNumber = parsePhoneNumber(value);
                if (phoneNumber) {
                    setCountryCode(phoneNumber.country);
                }
            } catch (error) {
                console.error("Error parsing phone number:", error);
            }
        }
    };

  // Modify your form submit to include the flag
 const handleSubmit = (e) => {
  e.preventDefault();
  const form = e.target;
  
  // Get the formatted phone number with country flag
  let formattedPhone = phoneValue;
  if (phoneValue && countryCode) {
    const countryChars = Array.from(countryCode.toUpperCase());
    const flagCodePoints = countryChars.map(char => 127397 + char.charCodeAt());
    const flagEmoji = String.fromCodePoint(...flagCodePoints);
    formattedPhone = `${flagEmoji} ${phoneValue}`;
  }

  // Create hidden input with formatted phone number
  const flagPhoneInput = document.createElement('input');
  flagPhoneInput.type = 'hidden';
  flagPhoneInput.name = 'phone';
  flagPhoneInput.value = formattedPhone;
  form.appendChild(flagPhoneInput);

  form.submit();
};

  return (
    <>
      <div className="nav-desktop-only">
        <NavBar />
      </div>
      <div className="contact-wrapper" dir={isRTL ? 'rtl' : 'ltr'}>
        <motion.div
          className="contact-container"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div className="contact-header" variants={cardVariants}>
            <h1>{t.contact?.title || "Get in Touch"}</h1>
            <p className="subtitle">
              {t.contact?.subtitle || "We'd love to hear from you. Whether you have a question about features, pricing, careers or anything else!"}
            </p>
          </motion.div>

          <div className="contact-grid">
            <motion.div className="contact-info" variants={cardVariants}>
              <div className="info-item">
                <div className="icon-circle">
                  <IoLocationSharp className="icon" />
                </div>
                <div className="info-text">
                  <h3>{t.contact?.labels?.location || "Location"}</h3>
                  <span>{t.contact?.details?.location || "Dubai, UAE"}</span>
                </div>
              </div>
              <div className="info-item">
                <div className="icon-circle">
                  <FaPhoneAlt className="icon" />
                </div>
                <div className="info-text">
                  <h3>{t.contact?.labels?.phone || "Phone"}</h3>
                  <a href="tel:+971503780135" className="phone-link">+971503780135</a>
                </div>
              </div>
              <div 
                className={`info-item ${selectedEmail === 'support@iwinto.com' ? 'active' : ''}`}
                onClick={() => setSelectedEmail('support@iwinto.com')}
              >
                <div className="icon-circle">
                  <FaEnvelope className="icon" />
                </div>
                <div className="info-text">
                  <h3>{t.contact?.labels?.support || "Support"}</h3>
                  <span>support@iwinto.com</span>
                </div>
              </div>
              <div 
                className={`info-item ${selectedEmail === 'invest@iwinto.com' ? 'active' : ''}`}
                onClick={() => setSelectedEmail('invest@iwinto.com')}
              >
                <div className="icon-circle">
                  <FaMoneyCheckAlt className="icon" />
                </div>
                <div className="info-text">
                  <h3>{t.contact?.labels?.investments || "Investments"}</h3>
                  <span>invest@iwinto.com</span>
                </div>
              </div>
            </motion.div>

            <div className="contact-form-container">
              {/* Selected Email Display */}
              <motion.div className="selected-email-display" variants={cardVariants}>
                <div className="email-display-content">
                  <FaEnvelope className="email-display-icon" />
                  <span>Messages will be sent to: <strong>{selectedEmail}</strong></span>
                </div>
              </motion.div>

              <motion.form
               onSubmit={handleSubmit}
                action={`https://formsubmit.co/${selectedEmail}`}
                method="POST"
                className="contact-form"
                variants={cardVariants}
              >
              <div className="form-group">
                <input 
                  type="text" 
                  name="name" 
                  placeholder=" " 
                  required 
                  className="form-contact-input"
                />
                <label className="form-label">{t.contact?.form?.name || "Your Name"}</label>
              </div>
              <div className="form-group">
                <input 
                  type="email" 
                  name="email" 
                  placeholder=" " 
                  required 
                  className="form-contact-input"
                />
                <label className="form-label">{t.contact?.form?.email || "Your Email"}</label>
              </div>
                <div className="form-group">
             <PhoneInput
    international
    defaultCountry="AE"
    value={phoneValue}
    onChange={handlePhoneChange}
    name="phone"
    id="phone"
    className="phone-input"
    placeholder=" "
    required
    withCountryCallingCode
/>
              <label className="form-label">{t.contact?.form?.phone || "Phone Number"}</label>
            </div>

              <div className="form-group textarea-group">
                <textarea 
                  name="message" 
                  placeholder=" " 
                  rows="5" 
                  required 
                  className="form-contact-input"
                ></textarea>
                <label className="form-label">{t.contact?.form?.message || "Your Message"}</label>
              </div>

              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_next" value="/thank-you" />

              <motion.button
                type="submit"
                className="contact-submit-btn"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
              >
                <span>{t.contact?.form?.submit || "Send Message"}</span>
                <FaPaperPlane className="send-icon" />
              </motion.button>
              </motion.form>
            </div>
          </div>
        </motion.div>
      </div>
      <Footer />
      <FloatingWebsiteNavigation />
    </>
  );
};

export default Contact;
